import { useEffect, useRef } from "react";
import { useState } from "react";
import { useSelector } from "react-redux";
import { useOutsideClick } from "./useOutsideClick";
import { formatCurrency } from "../../helpers/helpers";

export const MultiSelectionVariantes = ({ variantes, selectedServicio, selectedVariantes, handleVariantesChanged, variant = 'dropdown' }) => {
  const { colores } = useSelector(state => state.ui);
  const [isLoaded, setIsLoaded] = useState(false);
  const [visibility, setVisibility] = useState(false);
  // Comparación de IDs normalizada (servicios pueden ser ObjectId o objeto { _id })
  const servicioIdsSelected = new Set((selectedServicio || []).map(s => String(s._id || s)));
  let variantesBySelectedServices = variantes.filter((variante) => {
        return (variante.servicios || []).some((servicioIdOrObj) =>
          servicioIdsSelected.has(String(servicioIdOrObj?._id || servicioIdOrObj))
        );
  });

  useEffect(() => {
    const nombrePorServicioId = {};
    (selectedServicio || []).forEach((servicio) => {
        nombrePorServicioId[String(servicio._id || servicio)] = servicio.nombre;
    });

    variantesBySelectedServices.forEach((variante) => {
        (variante.servicios || []).forEach((servicioIdOrObj) => {
          const idStr = String(servicioIdOrObj?._id || servicioIdOrObj);
          if (nombrePorServicioId[idStr]) {
              let splitName = variante.nombre.split("-");
              if(splitName.length>1) variante.nombre = variante.nombre.split(" - ")[0];
              variante.nombre = variante.nombre + ' - ' + nombrePorServicioId[idStr];
          }
        });
    });
  }, [selectedServicio])
  
  const dropdownMenuRef = useRef();

  const toggleVisibility = () => {
    setVisibility(!visibility);
  }

  useEffect(() => {
    setIsLoaded(true)
  }, [])

  useEffect(() => {
    if (!isLoaded) return;

    const variantesValidas = selectedVariantes.filter(varianteSeleccionada => {
      return (varianteSeleccionada.servicios || []).some((servicioIdOrObj) =>
        servicioIdsSelected.has(String(servicioIdOrObj?._id || servicioIdOrObj))
      );
    });

    if (variantesValidas.length !== selectedVariantes.length) {
      handleVariantesChanged(variantesValidas);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedServicio, isLoaded])

  useOutsideClick(dropdownMenuRef, () => setVisibility(!visibility), visibility);

  const handleOnChange = (e) => {
    const { value, checked } = e.target;

    if (checked) {
      const nuevasVariantes = [...selectedVariantes, variantes.find(v => v._id === value)];
      handleVariantesChanged(nuevasVariantes);
    } else {
      const nuevasVariantes = selectedVariantes.filter(v => v._id !== value);
      handleVariantesChanged(nuevasVariantes);
    }
  }

  const isChecked = (variante) => {
    return selectedVariantes?.some(v => v._id === variante._id)
  }

  const handleToggle = (variante) => {
    if (isChecked(variante)) {
      handleVariantesChanged(selectedVariantes.filter(v => v._id !== variante._id));
    } else {
      handleVariantesChanged([...(selectedVariantes || []), variante]);
    }
  };

  if (variant === 'chips') {
    if (!selectedServicio?.length || !variantesBySelectedServices?.length) return null;
    return (
      <div className="variantes-chips">
        <p className="variantes-chips__label">Variantes</p>
        <div className="variantes-chips__row">
          {variantesBySelectedServices.map((variante) => {
            const isSelected = isChecked(variante);
            const valorCents = variante.valor != null ? parseFloat(variante.valor) : 0;
            const precioStr = valorCents !== 0 ? ` +${formatCurrency(valorCents)}€` : '';
            return (
              <button
                key={variante._id}
                type="button"
                className={`variantes-chips__chip ${isSelected ? 'variantes-chips__chip--selected' : ''}`}
                onClick={() => handleToggle(variante)}
              >
                {variante.nombre}
                {precioStr && <span className="variantes-chips__precio">{precioStr}</span>}
              </button>
            );
          })}
        </div>
      </div>
    );
  }

  return (
    <div className="brb-select">
      <div
        className={`brb-select-container ${visibility ? 'active' : ''}`}
        onClick={toggleVisibility}
      >
        <p>{selectedVariantes.length ? selectedVariantes.map(v => v.nombre).join(", ") : "Seleccione una variante"}</p>
        <div className="right-zone">
          <span
            className="select-arrow select-arrow-down"
          ></span>
        </div>
      </div>
      <div ref={dropdownMenuRef} className={`brb-select-options select-servicio ${visibility ? 'active' : ''}`}>

        {variantesBySelectedServices ?
          variantesBySelectedServices.map((variante) => {
            return (
              <div key={variante._id} className="brb-select-option" style={{ backgroundColor: colores.color6 }}>
                <input type="checkbox" id={variante._id} name={variante._id} value={variante._id} checked={isChecked(variante)} onChange={handleOnChange} />
                <label htmlFor={variante._id}>{variante.nombre}</label>
              </div>
            )
          })
		  :
		  <div>Selecciona algún servicio...</div>
        }
      </div>
    </div>
  )
};

